import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import { convertThenFormat } from "../../../common-data/Converts";

const IncentiveStatCards = () => {
  const { statsLoading, ptIntentivesStats, ptIntentivesStatsError } =
    useSelector((state) => state.incentives);

  const [allStatsData, setAllStatsData] = useState({});

  const getCardLabel = (key) => {
    switch (key) {
      case "total_earned_salary":
        return "total cost";
      default:
        return key.replace(/_/g, " ");
    }
  };

  useEffect(() => {
    if (
      ptIntentivesStats?.status &&
      ptIntentivesStats?.data &&
      !statsLoading &&
      !ptIntentivesStatsError
    ) {
      setAllStatsData(ptIntentivesStats.data[0]);
    } else {
      setAllStatsData({});
    }
  }, [statsLoading, statsLoading, ptIntentivesStatsError]);

  return (
    <div className="cards-container cards-grid-container grid-5 incentive-system">
      {statsLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <>
          {allStatsData &&
            Object.entries(allStatsData).map(([key, value], index) => {
              return (
                <React.Fragment key={index}>
                  {
                    <div
                      className={`pt-flow-new-stat-card-container`}
                      style={{ cursor: "not-allowed" }}
                    >
                      <div className="card-side card-right card-label-values">
                        <div className="card-mid">
                          <p className="card-mid-label">{getCardLabel(key)}</p>
                        </div>

                        <div className="card-bottom">
                          <p className="card-mid-value">
                            ₹{convertThenFormat(value || 0)}
                          </p>
                        </div>
                      </div>

                      <div className="card-side card-left card-top-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="44"
                          height="44"
                          viewBox="0 0 44 44"
                          fill="none"
                        >
                          <path
                            d="M38.7766 13.293H35.8432V27.7763H5.22656V30.7096H38.7766V13.293Z"
                            fill="#5A56E4"
                          />
                          <path
                            d="M34.007 8.52539H0.457031V25.9421H34.007V8.52539ZM5.7737 18.3337C5.13203 18.3337 4.58203 17.8754 4.58203 17.2337C4.58203 16.5921 5.13203 16.0421 5.7737 16.0421C6.41536 16.0421 6.96536 16.5921 6.96536 17.2337C6.8737 17.8754 6.41536 18.3337 5.7737 18.3337ZM17.232 24.1087C13.4737 24.1087 10.357 20.9921 10.357 17.2337C10.357 13.4754 13.4737 10.3587 17.232 10.3587C20.9904 10.3587 24.107 13.4754 24.107 17.2337C24.107 20.9921 20.9904 24.1087 17.232 24.1087ZM28.6904 18.3337C28.0487 18.3337 27.4987 17.7837 27.4987 17.1421C27.4987 16.5004 28.0487 15.9504 28.6904 15.9504C29.332 15.9504 29.882 16.5004 29.882 17.1421C29.7904 17.8754 29.332 18.3337 28.6904 18.3337Z"
                            fill="#5A56E4"
                          />
                          <path
                            d="M40.6089 18.0586V32.5419H9.99219V35.4753H43.5422V18.0586H40.6089Z"
                            fill="#5A56E4"
                          />
                          <path
                            d="M14.0247 12.6504H13.5664V14.0254H14.0247H17.3247C17.9664 14.0254 18.5164 14.3921 18.7914 14.9421H13.6581V16.3171H18.7914C18.5164 16.8671 17.9664 17.2337 17.3247 17.2337H14.0247V18.6087H14.3914L18.4247 22.7337L19.4331 21.8171L16.3164 18.7004H17.3247C18.6997 18.7004 19.8914 17.6921 20.1664 16.4087H20.6247V15.0337H20.1664C20.0747 14.6671 19.9831 14.3921 19.7997 14.1171H20.7164V12.7421H17.3247H14.0247V12.6504Z"
                            fill="#5A56E4"
                          />
                        </svg>
                      </div>
                    </div>
                    // <DashboardCard
                    //   tagName={key}
                    //   cardLabel={key?.replace(/_/g, " ")}
                    //   value={`${convertThenFormat(value || 0)}`}
                    //   onClickCard={handleCardClick}
                    //   cardIndex={index}
                    //   isActiveCard={activeCardIndex === key}
                    // />
                  }
                </React.Fragment>
              );
            })}
        </>
      )}
    </div>
  );
};

export default IncentiveStatCards;
